var $06546dd9bbf0f542$exports = {};
$06546dd9bbf0f542$exports = {
    "longPressMessage": `Nor\u{117}dami atidaryti meniu, nuspaud\u{119} palaikykite arba paspauskite \u{201E}Alt + ArrowDown\u{201C}.`
};


export {$06546dd9bbf0f542$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
